import { createFileRoute } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { useEffect } from "react";
import { config } from "@/config";
import { api } from "@/lib/api";

interface PartnerResponse {
	data: {
		partner_type?: string;
	};
}

export const Route = createFileRoute("/flex/$id")({
	component: FlexRedirect,
});

function FlexRedirect() {
	const { id: partnerUuid } = Route.useParams();

	useEffect(() => {
		const baseUrl = config.urls.webServiceUrl.replace(/\/$/, "");

		// Dead link (partner deleted, mistyped or truncated canonical): send the
		// visitor to the home page with no UTMs, so nothing is attributed to it.
		const redirectHome = () => {
			window.location.replace(`${baseUrl}/`);
		};

		const redirect = async () => {
			let utmMedium = "sharing_link";
			let partnerExists = false;

			console.log("[FlexRedirect] Starting redirect flow", {
				partnerUuid,
				webServiceUrl: config.urls.webServiceUrl,
			});

			try {
				const response = await api.get<PartnerResponse>(
					`/api/v0/leads/partners/${partnerUuid}`,
					{ params: { methods: "partner_type" } },
				);

				console.log("[FlexRedirect] API response", {
					status: response.status,
					data: response.data,
					hasData: !!response.data?.data,
				});

				if (response.data?.data) {
					partnerExists = true;
					if (response.data.data.partner_type) {
						utmMedium = response.data.data.partner_type;
					}
				}
			} catch {
				redirectHome();
				return;
			}

			if (!partnerExists) {
				redirectHome();
				return;
			}

			const queryString = new URLSearchParams({
				utm_source: partnerUuid,
				utm_medium: utmMedium,
				utm_campaign: "partner",
				partner_source: partnerUuid,
			}).toString();

			window.location.href = `${baseUrl}?${queryString}`;
		};

		redirect();
	}, [partnerUuid]);

	return (
		<div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white">
			<div className="flex flex-col items-center gap-6">
				<Loader2 className="h-16 w-16 animate-spin text-[#3F83F8]" />
				<div className="text-center">
					<h1 className="text-xl font-semibold text-gray-900 mb-2">
						Redirecting you...
					</h1>
				</div>
			</div>
		</div>
	);
}
